module.exports = __webpack_public_path__ + "static/media/health-and-safety-executive-logo-charcoal.a70d9868.svg";